export const SsoProvider = {
    EntraId: 'entra_id',
};
export const SSO_PROVIDERS = Object.values(SsoProvider);
//# sourceMappingURL=Sso.js.map